exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.select-intervenant .dropdown-toggle {\n    border: none;\n}\n.select-intervenant input[type=search],\n.select-intervenant input[type=search]:focus {\n    height: 30px;\n}\n.select-intervenant .dropdown {\n    width: 70%;\n}\n.select-intervenant .role-select-new,\n.select-intervenant .role-select-edit {\n    width: 20rem;\n    flex:none;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n.select-intervenant .role-select-edit {\n    margin: -1px;\n    margin-left: -2px;\n}\n.select-intervenant .v-select .open-indicator {\n    line-height: 1.2rem;\n}\n.select-intervenant .v-select .open-indicator::before {\n    vertical-align:unset;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-42468998","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./_wwwsrc/js/Workflow/Components/Input/SelectIntervenant.vue
// module id = 562
// module chunks = 0